module.exports = {"appName":"Program Ishrane","webDesign":"Web design"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/translations/en.json
// module id = 9V52
// module chunks = 0